export default __webpack_public_path__ + "static/media/ordinacija-reverse.55b35395.mp4";